import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, ActivityIndicator, Picker, Platform } from 'react-native';
import { Flex, Padding, Margin, Helpers, Typo, article, button, articleItem,FontFamily,articleLists } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import ScrollContainerView from '../scroll-container-view';
import { helpers } from '../../utils/helpers';
import PageBreak from '../page-break';
import ArticleItem from '../article-item';
import Cookies from "universal-cookie";
import AuthenticationWrapper from '../authentication-wrapper';

const cookies = new Cookies();


export class HomeFromArchives extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const {isAuthenticated, fetchToken} = this.props.auth
        let token = webView ? (process.browser ? (isAuthenticated?fetchToken:false) : this.props.token) : this.props.user?.userData?.data?.token;
        this.state = {
            showToken: (!helpers.isWeb() || process.browser) ? true : false,
        }
    }

    componentDidMount = () => {
    }

    viewMoreArticles = () => {
        const { viewAllArticles } = this.props;
        viewAllArticles()
    }

    viewArticle = (catSlug, slug, postData) => {
        const { viewArticle } = this.props;
        viewArticle(catSlug, slug, postData)
    }

    viewAuthor = (slug) => {
        const { viewAuthor } = this.props;
        viewAuthor(slug)
    }
    viewCategory = (slug) => {
        const { viewCategory } = this.props;
        viewCategory(slug)
    }

    render() {
        const { data, categorySlug } = this.props;
        let btnClick,btnClickCategory;
        if (helpers.isWeb()) {
            btnClick = {
                to: "/category/" + categorySlug + "/all"
            };
         
        } else {
            btnClick = {
                onPress: () => this.viewMoreArticles()
            }
        }
        return (
            
            <View style={[helpers.isDesktop() && Padding.ph_2,Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWebFull, helpers.isDesktop() && {marginBottom: 0 }]}>
                {helpers.isDesktop () ?
                    <View style={[article.headerWrapper]}>
                        <View style={[Flex.alignCenter, Margin.mb_7, !helpers.isDesktop() && Margin.mb_4]}>
                            <View style={[Padding.ph_2, Helpers.titleBgWrap]}>
                                <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop,  Margin.mb_0, {fontSize: 18},{fontFamily:FontFamily.abrilFatface}, {fontSize: helpers.isDesktop() ? 30 : 18} ]}>From the archives</Text>
                            </View>
                            <PageBreak />
                        </View>                
                    </View>
                    :
                    <View style={[article.headerWrapper, Margin.mt_5]}>
                        <View style={[Flex.alignCenter, Margin.mb_7, !helpers.isDesktop() && Margin.mb_4]}>
                            <View style={[Padding.ph_2, Helpers.titleBgWrap]}>
                                <View style={[Helpers.borderBottom]}>
                                    <Text style={[Helpers.textCenter,Helpers.textUppercase, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, {fontSize: 18},{fontFamily:FontFamily.regular}, {fontSize: helpers.isDesktop() ? 30 : 18} ]}>From the archives</Text>
                                </View>
                            </View>
                            <View style={[Helpers.titleLine]}></View>
                        </View>                
                    </View>
                }
                <View style={[!helpers.isDesktop() && Padding.ph_2, Margin.mt_3, Margin.mb_4]}>
                    { helpers.isDesktop() ?
                    <ScrollContainerView horizontal={false} showsHorizontalScrollIndicator={false}>
                        <View style={[Flex.row, !process.browser && {overflow: 'hidden'}]}>
                            {data && data.map((item, index) => {
                                if (helpers.isWeb()) {
                                    btnClickCategory = {
                                        to: "/category/" + item.category.slug
                                    }
                                } else {
                                    btnClickCategory={
                                        onPress: () => this.viewCategory(item.category.slug)
                                    }
                                }
                                return (
                                    <View style={[articleItem.col4, helpers.isDesktop() && articleItem.col4Desktop]}>
                                        <TouchableOpacityLink {...btnClickCategory}>
                                            <View>
                                                <Text style={[articleLists.badge, { width: 150, marginBottom: 15, textAlign: 'left', fontFamily: FontFamily.regular, color: '#907cff' }, !helpers.isWeb() && {fontFamily: FontFamily.semiBold}]}>{item.category.name}</Text>
                                            </View>
                                        </TouchableOpacityLink>
                                        <ArticleItem viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} home={true} hideImage={true}/>
                                    </View>
                                )
                            })}
                        </View>
                    </ScrollContainerView>
                    :
                    <ScrollContainerView horizontal={true}   showsHorizontalScrollIndicator={false}>
                        <View style={[Flex.row, !process.browser && {overflow: 'hidden'}]}>
                            {data && data.map((item, index) => {
                                if (helpers.isWeb()) {
                                    btnClickCategory = {
                                        to: "/category/" + item.category.slug
                                    }
                                } else {
                                    btnClickCategory={
                                        onPress: () => this.viewCategory(item.category.slug)
                                    }
                                }
                                return (
                                    <View style={[articleItem.col3, helpers.isDesktop() && articleItem.col3Desktop]}>
                                        <TouchableOpacityLink {...btnClickCategory}>
                                            <View>
                                                <Text style={[articleLists.badge, { width: 150, marginBottom: 15, textAlign: 'left', fontFamily: FontFamily.regular, color: '#907cff' }, !helpers.isWeb() && {fontFamily: FontFamily.semiBold}]}>{item.category.name}</Text>
                                            </View>
                                        </TouchableOpacityLink>
                                        <ArticleItem viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} home={true} hideImage={true}/>
                                    </View>
                                )
                            })}
                        </View>
                    </ScrollContainerView>
                }
                    {helpers.isDesktop() &&
                        <View style={[Flex.alignCenter, Margin.mt_4, { marginTop: helpers.isDesktop() ? 50 : 40 }, helpers.isDesktop() && { marginBottom: 50}]}>
                            <TouchableOpacityLink
                                {...btnClick}
                            >
                                <View style={[Flex.row, Flex.alignCenter]}>
                                    <Text style={[button.secondaryOutline, helpers.isDesktop() && button.secondaryOutlineDesktop,  Helpers.textUppercase, Margin.mr_0,{fontWeight: '300'}]}>View all articles</Text>
                                </View>
                            </TouchableOpacityLink>
                        </View>
                    }
                </View>
            </View>
        );
    }
}

export default AuthenticationWrapper(HomeFromArchives);
